class r {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(a) {
    return !!a.match(/^((0[1-9])|([1-4][0-9])|50|51|52)[0-9]{3}$/);
  }
}
export {
  r as default
};
